<div id="openGroupDetailExtends" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" *ngIf="book != null">
        <h4 class="modal-title mt-0 w-100">Datos de grupo |
          <span class="bold">{{book.code}}</span>
        </h4>
        <button type="button" class="close" data-dismiss="modal" (click)="close()">&times;</button>
      </div>
      <app-loading-modal></app-loading-modal>
      <div class="modal-body p-t-0" *ngIf="book != null">
        <div class="card m-b-20">
          <div class="card-body p-l-5 p-r-5 p-t-5 p-b-0 faq-box boder-left-{{book.status_group.class}}">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview">
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__background">
                <div id="test" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail position-relative">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left bold">Destino</div>
                    <div class="child-right bold">
                      {{book.tour_data.description}}
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left">Estado</div>
                    <div class="child-right">
                      <span class="badge f-s-12 badge-{{book.status_group.class}}">{{book.status_group.message}}</span>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left">Código</div>
                    <div class="child-right">
                      <span class="bold color-link">{{book.code}}</span>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left">Fecha de salida</div>
                    <div class="child-right">
                      {{book.date_departure}}
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left">Guía de viaje</div>
                    <div class="child-right">
                      {{book.guide_data.fullname}} - CEL: {{book.guide_data.cellphone}}
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left">Transporte</div>
                    <div class="child-right">
                      {{book.transport_data.owner}} - CEL: {{book.transport_data.cellphone}}
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left">Capacidad Transporte</div>
                    <div class="child-right">
                      {{book.transport_data.capacity}} - placa:
                      <span>{{book.transport_data.license_plate}}</span>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left">Pasajeros</div>
                    <div class="child-right bold">
                      {{book.capacity_selected}} <span class="m-l-5">seleccionados</span>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 proview__detail__row">
                    <div class="child-left">Observaciones</div>
                    <div class="child-right">
                      <span>{{book.observations}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="thead-default">
                <tr>
                  <th class="text-center">N° PAX</th>
                  <th>Responsable y Código</th>
                  <th class="text-center"># Proforma</th>
                  <th>Hotel / Ubicacion</th>
                  <th>Teléfonos</th>
                  <th>Observaciones</th>
                  <th>Deuda</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="bookings.length > 0">
                  <tr *ngFor="let item of bookings">
                    <td class="text-center f-s-13">
                      {{item.quantity}}
                    </td>
                    <td class="f-s-13">
                      {{item.client}}
                      <p class="f-s-10 bold m-b-0" *ngIf="item.is_received"><span
                          class="badge badge-success">Recibido</span> | {{item.agency_reponsible}}</p>
                      <p class="m-b-2">
                        <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite f-s-14"></i>
                        <span class=" f-s-11 bold pointer book__code">{{item.code}}</span>
                      </p>
                      <div class="d-inline-block" *ngIf="item.is_reference_pax">
                        REF:
                        <span>Niños ({{item.nro_pax_childs}})</span>,
                        <span>Adultos({{item.nro_pax_adults}})</span>,
                        <span>Ancianos ({{item.nro_pax_olds}})</span>
                      </div>
                    </td>
                    <td class="text-center">{{item.reference_voucher}}</td>
                    <td class="f-s-13">{{item.reference_location}}</td>
                    <td class="f-s-13">
                      <div>{{item.tel_1}}</div>
                      <div *ngIf="item.tel_2 != null">
                        {{item.tel_2}}
                      </div>
                    </td>
                    <td>
                      {{item.observations}}
                      <div *ngIf="item.observation != null">
                        | <span class="bold">{{item.observation}}</span>
                      </div>
                    </td>
                    <td class="f-s-13">{{item.total - item.total_paid | currency:'S/ '}}</td>
                  </tr>
                </ng-container>


              </tbody>
            </table>
          </div>
        </div>
        <div class="col-12">
          <p class="m-b-5">
            <i class="fas fa-star m-r-2 color-favorite f-s-14"></i> Se consideran reservas importantes (Referencia de un
            trato especial)
          </p>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary close-btn" data-dismiss="modal" (click)="close()">Cerrar</button>
      </div>
    </div>
  </div>
</div>
